var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneFilled = function SvgPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.244 5.395 5.74 2.902a1.894 1.894 0 0 1 2.688 0l2.686 2.686a1.896 1.896 0 0 1 0 2.688L9.15 10.24a9.23 9.23 0 0 0 1.887 2.72 9.265 9.265 0 0 0 2.72 1.895l1.965-1.964a1.896 1.896 0 0 1 2.688 0l2.688 2.683a1.897 1.897 0 0 1 0 2.69l-2.491 2.492a3.08 3.08 0 0 1-2.67.858c-3.159-.52-6.292-2.2-8.821-4.727-2.527-2.524-4.205-5.656-4.732-8.825a3.085 3.085 0 0 1 .86-2.667Z",
    fill: "#fff"
  })));
};
export default SvgPhoneFilled;